import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown, ArrowRight, LogOut, User } from "lucide-react";
import logo from "../Assests/ll.webp";
import { useAuth } from "../context/AuthContext";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  // { label: "Growth Hub", to: "/programs" },
  { label: "Parents Testimonials", to: "/testimonials" },
  { label: "Gallery", to: "/gallery" },
  { label: "Blog", to: "/blog" },
  { label: "Contact Us", to: "/contact" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { currentUser, logout, isAdmin } = useAuth();
  const isLoggedIn = Boolean(currentUser);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/55 backdrop-blur-md px-6 lg:px-16 py-5">
      <div className="max-w-[1280px] mx-auto flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <div className="w-auto h-20 width-auto bg-white rounded-lg overflow-hidden">
            <img src={logo} alt="Kiddin Logo" className="w-full h-full object-cover" />
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <NavLink
              key={link.label}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-1 text-sm font-semibold transition-colors duration-200 ${
                  isActive
                    ? "text-[#FF6B35]"
                    : "text-white hover:text-[#FF6B35]"
                }`
              }
            >
              {link.label}
              {link.hasDropdown && <ChevronDown size={14} strokeWidth={2.5} />}
            </NavLink>
          ))}
        </nav>

        {/* Auth Buttons */}
        <div className="hidden lg:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="flex items-center gap-2 bg-white/20 rounded-full px-4 py-2">
                <User size={16} className="text-white" />
                <span className="text-white text-sm font-medium">
                  {currentUser?.name || currentUser?.email?.split("@")[0]}
                </span>
              </div>
              {isAdmin && (
                <Link
                  to="/admin"
                  className="flex items-center gap-2 bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold text-sm px-6 py-3 rounded-full transition-all duration-300"
                >
                  Dashboard
                </Link>
              )}
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white font-bold text-sm px-6 py-3 rounded-full transition-all duration-300"
              >
                Logout <LogOut size={16} />
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="flex items-center gap-2 bg-white/20 hover:bg-white/30 text-white font-bold text-sm px-6 py-3 rounded-full transition-all duration-300"
              >
                Log In
              </Link>
              <Link
                to="/signup"
                className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold text-sm px-6 py-3 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-orange-500/30 hover:-translate-y-0.5"
              >
                Get Started <ArrowRight size={16} strokeWidth={2.5} />
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="lg:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden mt-4 bg-white/95 backdrop-blur-lg rounded-2xl p-6 shadow-2xl">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className="flex items-center justify-between py-3 border-b border-gray-100 text-sm font-semibold text-gray-700"
            >
              {link.label}
              {link.hasDropdown && <ChevronDown size={14} />}
            </Link>
          ))}
          
          {isLoggedIn ? (
            <>
              <div className="py-3 border-b border-gray-100 text-sm font-semibold text-gray-700">
                Welcome, {currentUser?.name || currentUser?.email?.split("@")[0]}
              </div>
              {isAdmin && (
                <Link
                  to="/admin"
                  onClick={() => setMenuOpen(false)}
                  className="mt-4 flex items-center justify-center gap-2 bg-cyan-500 text-white font-bold text-sm px-6 py-3 rounded-full w-full"
                >
                  Dashboard
                </Link>
              )}
              <button
                onClick={() => {
                  handleLogout();
                  setMenuOpen(false);
                }}
                className="mt-4 flex items-center justify-center gap-2 bg-red-500 text-white font-bold text-sm px-6 py-3 rounded-full w-full"
              >
                Logout <LogOut size={16} />
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                onClick={() => setMenuOpen(false)}
                className="mt-4 flex items-center justify-center gap-2 bg-white border-2 border-[#FF6B35] text-[#FF6B35] font-bold text-sm px-6 py-3 rounded-full w-full"
              >
                Log In
              </Link>
              <Link
                to="/signup"
                onClick={() => setMenuOpen(false)}
                className="mt-4 flex items-center justify-center gap-2 bg-[#FF6B35] text-white font-bold text-sm px-6 py-3 rounded-full w-full"
              >
                Get Started <ArrowRight size={16} />
              </Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
